module.exports = __webpack_public_path__ + "img/blown_up_aunt_marge.22952fc1.jpg";